export default "__VITE_ASSET__BKQUFh_k__"